export function numberWithDelimiter(delimiter, number) {
  if (delimiter == '.') {
    return number.toLocaleString('de-DE', { minimumFractionDigits: 2 });
  } else {
    return number.toLocaleString('en-US', { minimumFractionDigits: 2 });
  }
}
